import { FC, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

/** Centered empty/info state shown in place of a matrix grid. */
export const MatrixMessage: FC<{ children: ReactNode }> = ({ children }) => (
  <Box
    sx={{
      flex: 1,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      textAlign: "center",
      color: "text.secondary",
      px: 3,
      py: 6,
    }}
  >
    <Typography variant="body1" sx={{ maxWidth: 460 }}>
      {children}
    </Typography>
  </Box>
);
